// extracted by mini-css-extract-plugin
export default {"ConsentForm":"ConsentForm_ConsentForm__gt+uh","title":"ConsentForm_title__ZxoVc","request":"ConsentForm_request__H+9M6"};